import Header from './Header';
import Bio from './Bio';
import './Main.css';

const Main = () => {    
    return(
        <div className='container'>
            <Header/>
            <Bio />
        </div>
    );
};

export default Main;